import React, { useState } from 'react'
import {Link, Redirect, useParams} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'

import { toast } from 'react-toastify'
import * as yup from 'yup'
import { Helmet } from 'react-helmet'
import pick from 'lodash/pick'
import mapValues from 'lodash/mapValues';

import { Heading } from '@peracto/peracto-ui'
import { CREATE, useClient, getSchemaFromResource } from '@peracto/client'
import { MODE_ADD } from '../ProductOptionDetailsForm'

const ProductOptionDetailsAddContainer = ({ children }) => {
    const { id } = useParams();

    return (
        <div className="form-container">
            <Heading name="Add Product Option Detail">
                <div className="flex-grow-1 d-flex align-items-center justify-content-end">
                    <Link
                        className="btn btn-outline-primary"
                        to={`/options/${id}/details`}
                        data-testid="back-to-product-option-details"
                    >
                        <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />
                        Back to Product Option Details
                    </Link>
                </div>
            </Heading>
            {children}
        </div>
    )
}

const ProductOptionDetailsAdd = ({ ProductOptionDetailsForm }) => {
    const { client, getResource } = useClient()
    const [redirect, setRedirect] = useState()
    const { id } = useParams();
    const schema = getSchemaFromResource(getResource('product-option-details')).shape({
        variantOptionIdentifier: yup.string().required(),
        productOption: yup.string().required(),
    })

    const onSubmit = async (data, actions) => {
        const pickedData = pick(data, ['productOption', 'variantOptionIdentifier', 'location', 'description', 'bestSeller', 'expressDelivery', 'justAdded', 'excludedFromSwatchRequests'])
        const productOptionDetailsData = mapValues(pickedData, (value) => (value === "" ? null : value));

        try {
            const response = await client(CREATE, 'product-option-details', {
                data: productOptionDetailsData,
            })

            if (response.data.violations && response.data.violations.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                for (const error of response.data.violations) {
                    actions.setFieldError(error.propertyPath, error.message);
                }
            } else {
                setRedirect(`/options/${id}/details/${response.data.originId}`)
                toast.success('Product Option Detail successfully added!')
                actions.setSubmitting(false)
            }
        } catch (e) {
            console.error(e)
            if (e?.error?.body?.violations && e.error.body.violations.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                for (const error of e.error.body.violations) {
                    actions.setFieldError(error.propertyPath, error.message);
                }
            }
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )
            actions.setSubmitting(false)
            actions.setValues(productOptionDetailsData)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <ProductOptionDetailsAddContainer>
            {redirect && <Redirect to={redirect} />}

            <Helmet>
                <title>Product Option Details | Add | Peracto</title>
            </Helmet>

            <ProductOptionDetailsForm onSubmit={onSubmit} mode={MODE_ADD} schema={schema} />
        </ProductOptionDetailsAddContainer>
    )
}

export default ProductOptionDetailsAdd
